import React from "react";
import PropTypes from "prop-types";
import { IconAlert, IconWarning, ModalClosed, ModalSuccess } from "~misc/icons";
import { Link } from "react-router-dom";

import "../style.scss";

const ModalReflex = ({
  isOpen,
  closeModal,
  status,
  message,
  submessage,
  list,
  button = "Fechar",
  link = null,
  setOfflineReridect,
  idCliente,
  checkRouteRoteirizacao,
  checkin,
}) => {
  const modalStyle = `fixed top-0 left-0 w-full h-full flex items-center justify-center z-[99999] ${
    isOpen ? "" : "hidden"
  }`;

  const contentStyle = "bg-white relative mx-4 px-20 py-10 rounded-tr-[20px] text-center z-[100] max-h-[50rem]";

  const statusMap = {
    success: <ModalSuccess />,
    alert: <IconAlert />,
    warning: <IconWarning />,
  };

  return (
    <div
      className={modalStyle}
      style={{ background: "rgba(0, 0, 0, 0.5)" }}
      data-testid="modal-response"
      role="dialog"
      aria-modal="true"
    >
      <div className={contentStyle} data-testid="modal-content">
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => closeModal()}
            className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
          >
            <ModalClosed />
          </button>
        </div>

        <span className="flex justify-center mb-2" data-testid="modal-status-icon">
          {statusMap[status]}
        </span>

        <p
          className="font-bold text-lg block text-[#E4532E] text-[25px] max-w-[600px] mx-auto"
          data-testid="modal-message"
        >
          {message}
        </p>

        {Array.isArray(list) && list.length > 0 && (
          <div className="flex flex-col gap-2 my-6 overflow-auto max-h-[35rem]">
            {list.map((name) => (
              <span key={name} className="bg-[#E6E6E6] text-[#01054C] font-semibold py-2 px-4 rounded">
                {name}
              </span>
            ))}
          </div>
        )}

        {submessage && <h4 className="mt-2 font-bold text-[20px]">{submessage}</h4>}

        <span data-testid="modal-status" className="sr-only">
          {status}
        </span>
      </div>
    </div>
  );
};

ModalReflex.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  status: PropTypes.oneOf(["success", "alert", "warning"]).isRequired,
  message: PropTypes.string.isRequired,
  submessage: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  button: PropTypes.string,
  link: PropTypes.string,
  setOfflineReridect: PropTypes.func,
  idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checkRouteRoteirizacao: PropTypes.func,
  checkin: PropTypes.shape({
    clienteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

ModalReflex.defaultProps = {
  button: "Fechar",
  link: null,
  submessage: "",
  list: [],
  setOfflineReridect: null,
  idCliente: null,
  checkRouteRoteirizacao: null,
  checkin: null,
};

export default ModalReflex;
